module.exports = __webpack_public_path__ + "static/img/thai_qr_img_4.4d6c4bba.png";